
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.15.0
 * Query Engine version: 659ef412370fa3b41cd7bf6e94587c1dfb7f67e7
 */
Prisma.prismaVersion = {
  client: "4.15.0",
  engine: "659ef412370fa3b41cd7bf6e94587c1dfb7f67e7"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val


/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.ActivityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  type: 'type',
  isTotallyPrivate: 'isTotallyPrivate',
  isTotallyPublic: 'isTotallyPublic',
  userId: 'userId',
  userToNotifyId: 'userToNotifyId',
  blockId: 'blockId',
  pageId: 'pageId'
};

exports.Prisma.AgreeScalarFieldEnum = {
  id: 'id',
  updatedAt: 'updatedAt',
  title: 'title',
  agreeCount: 'agreeCount',
  agreeReCount: 'agreeReCount'
};

exports.Prisma.BlockScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  isSoftDeleted: 'isSoftDeleted',
  top: 'top',
  left: 'left',
  width: 'width',
  height: 'height',
  zIndex: 'zIndex',
  pageId: 'pageId',
  embeddedBlockId: 'embeddedBlockId',
  embeddedPageId: 'embeddedPageId',
  userId: 'userId',
  plainText: 'plainText',
  textContent: 'textContent',
  rawContent: 'rawContent',
  caption: 'caption',
  description: 'description',
  filename: 'filename',
  originalFilename: 'originalFilename',
  fileSize: 'fileSize',
  hex: 'hex',
  codeLanguage: 'codeLanguage',
  imageFit: 'imageFit',
  hasUploadedFile: 'hasUploadedFile',
  fileStatus: 'fileStatus',
  textSubtype: 'textSubtype',
  labelAnnotations: 'labelAnnotations',
  webDetection: 'webDetection',
  imageProperties: 'imageProperties',
  customTags: 'customTags'
};

exports.Prisma.FeatureFlagsScalarFieldEnum = {
  id: 'id',
  rawViewScore: 'rawViewScore',
  likedScore: 'likedScore',
  pageEmbedScore: 'pageEmbedScore',
  halfLife: 'halfLife'
};

exports.Prisma.InviteScalarFieldEnum = {
  id: 'id',
  invitedById: 'invitedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mnemonic: 'mnemonic',
  expiration: 'expiration',
  claimed: 'claimed',
  superInvite: 'superInvite'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.LikesOnUsersScalarFieldEnum = {
  id: 'id',
  blockId: 'blockId',
  userId: 'userId',
  pageId: 'pageId',
  likedAt: 'likedAt'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.PageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  height: 'height',
  width: 'width',
  isSoftDeleted: 'isSoftDeleted',
  userId: 'userId',
  title: 'title',
  isPublic: 'isPublic',
  isFeatured: 'isFeatured',
  isExample: 'isExample',
  permissionId: 'permissionId',
  screenshotTime: 'screenshotTime',
  totalViews: 'totalViews'
};

exports.Prisma.PermissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ownerId: 'ownerId'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.QuoteScalarFieldEnum = {
  id: 'id',
  text: 'text'
};

exports.Prisma.ResponseScalarFieldEnum = {
  id: 'id',
  text: 'text',
  quoteId: 'quoteId',
  phoneNumber: 'phoneNumber'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  username: 'username',
  displayName: 'displayName',
  email: 'email',
  emailVerified: 'emailVerified',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  avatarUrl: 'avatarUrl',
  passwordHash: 'passwordHash',
  generatedKey: 'generatedKey',
  verifiedKey: 'verifiedKey',
  bio: 'bio',
  badges: 'badges',
  inviteId: 'inviteId',
  overloadInviteId: 'overloadInviteId',
  notificationsClearedAt: 'notificationsClearedAt',
  sharedPagesClearedAt: 'sharedPagesClearedAt',
  settings: 'settings',
  remainingInvites: 'remainingInvites',
  isGoodFollow: 'isGoodFollow',
  onboardingComplete: 'onboardingComplete',
  registeredWithUrbit: 'registeredWithUrbit'
};

exports.Prisma.ViewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  pageId: 'pageId',
  viewerId: 'viewerId'
};

exports.Prisma.WaitlistScalarFieldEnum = {
  id: 'id',
  updatedAt: 'updatedAt',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  comment: 'comment',
  twitter: 'twitter',
  isInvited: 'isInvited'
};
exports.ActivityType = {
  FOLLOW: 'FOLLOW',
  SIGNUP: 'SIGNUP',
  BLOCK_CREATE: 'BLOCK_CREATE',
  PAGE_POSTED: 'PAGE_POSTED',
  PAGE_SHARED: 'PAGE_SHARED',
  ADMIN_ANNOUNCEMENT: 'ADMIN_ANNOUNCEMENT',
  BLOCK_OR_PAGE_LIKE: 'BLOCK_OR_PAGE_LIKE'
};

exports.BlockType = {
  text: 'text',
  image: 'image',
  color: 'color',
  linkEmbed: 'linkEmbed',
  spotifyEmbed: 'spotifyEmbed',
  youtubeEmbed: 'youtubeEmbed',
  twitterEmbed: 'twitterEmbed',
  instagramEmbed: 'instagramEmbed',
  file: 'file',
  blockWindow: 'blockWindow',
  pageWindow: 'pageWindow',
  code: 'code'
};

exports.FileStatus = {
  UPLOADING: 'UPLOADING',
  UPLOADED: 'UPLOADED',
  FAILED: 'FAILED'
};

exports.ImageFit = {
  cover: 'cover',
  contain: 'contain'
};

exports.TextSubtype = {
  quote: 'quote',
  monospace: 'monospace',
  plain: 'plain',
  headerOne: 'headerOne',
  headerTwo: 'headerTwo'
};

exports.Prisma.ModelName = {
  User: 'User',
  Invite: 'Invite',
  Block: 'Block',
  Activity: 'Activity',
  Page: 'Page',
  View: 'View',
  Permission: 'Permission',
  LikesOnUsers: 'LikesOnUsers',
  Agree: 'Agree',
  Waitlist: 'Waitlist',
  Quote: 'Quote',
  Response: 'Response',
  FeatureFlags: 'FeatureFlags'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
